module.exports = __webpack_public_path__ + "static/media/area.63a01ac5.svg";